// Small "BIP" sound used to signal a successful action (e.g. customer
// consent received during onboarding). Synthesised via Web Audio so we
// don't need to ship an audio asset.
//
// Two short tones (high → higher) ≈ 250ms total. Volume capped low to
// avoid startling the cashier in a quiet venue.

let _ctx = null;

function getContext() {
  if (_ctx) return _ctx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    _ctx = new Ctx();
    return _ctx;
  } catch {
    return null;
  }
}

export function playBip() {
  const ctx = getContext();
  if (!ctx) return;
  // Some browsers (Safari/Chrome on iOS) suspend the context until a user
  // gesture. Best-effort resume — if it stays suspended, the bip is just
  // skipped silently.
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
  const now = ctx.currentTime;
  const tone = (freq, start, dur) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0, now + start);
    gain.gain.linearRampToValueAtTime(0.18, now + start + 0.01);
    gain.gain.linearRampToValueAtTime(0, now + start + dur);
    osc.connect(gain).connect(ctx.destination);
    osc.start(now + start);
    osc.stop(now + start + dur + 0.02);
  };
  tone(880, 0, 0.12);    // A5
  tone(1320, 0.13, 0.14); // E6
}
